import { render, staticRenderFns } from "./IntegrationDetails.vue?vue&type=template&id=f125fdd6"
import script from "./IntegrationDetails.vue?vue&type=script&lang=js"
export * from "./IntegrationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports